import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import { Paper, TableContainer, TableHead, TableRow, TableCell, Table, TableBody, Checkbox, Typography } from '@material-ui/core';
import ReactLoading from 'react-loading';


const headCells = [
    { id: 'check', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left', displayFlg: true},
    { id: 'address', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left', displayFlg: true},
    { id: 'fullName', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left', displayFlg: true},
    { id: 'participate', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left', displayFlg: true},
    { id: 'userId', numeric: false, disablePadding: false, label: 'ユーザーID', width: 'auto', textAlign: 'left', displayFlg: true},
    { id: 'status', numeric: false, disablePadding: false, label: '状態', width: 'auto', textAlign: 'left', displayFlg: true},
];

const styles = () => ({
    paper: {
        width: '95%',
        marginTop: '20px',
    },
    tableHeadColor: {
        backgroundColor: '#edeff0',
        borderColor: '#dee2e6',
        color: '#495057',
    },
    table: {
        minWidth: 1000,
    },
    cell: {
        display: 'block',
    },
    wordBreak: {
        width: '100%',
        wordBreak: 'break-all',
        whiteSpace: 'pre-wrap',
    },
    lengthTypography: {
        fontSize: '18px',
        marginTop: '10px'
    },
    center: {
        justifyContent: 'center',
        alignItems:'center',
        margin: '50px auto 50px auto',
    }
});

function ChatUserTableHead(props) {
    const { classes, order, orderBy, allUpdateFlg, allUpdate, allData } = props;

    return (
        <React.Fragment>
            <TableHead className={classes.tableHeadColor}>
                <TableRow>
                    {headCells.map((headCell) => {
                        return (
                            ( (headCell.displayFlg && allData.length !== 0 ) && (
                                <TableCell
                                    key={headCell.id}
                                    align={headCell.numeric ? 'right' : 'left'}
                                    padding={headCell.disablePadding ? 'none' : 'default'}
                                    sortDirection={orderBy === headCell.id ? order : false}
                                >
                                    {headCell.label}
                                    { headCell.id === 'check'  && (
                                        <Checkbox
                                            checked={allUpdateFlg}
                                            onChange={(event) => allUpdate(event)}
                                        />
                                    )}
                                </TableCell>
                            ))
                        );
                    })}
                </TableRow>
            </TableHead>
        </React.Fragment>
    );
}

const ChatUserTable = withCookies((props) => {
    const { classes, datas, allData, setData, cookies, allUpdate, setAllUpdate, isLoading } = props;
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('address');
    const [update, setUpdata]= React.useState(false);
    const chatNameObj = cookies.get('COMMON_NAME_OBJ');
    const inchatName = chatNameObj !== undefined ? chatNameObj.INCHAT_NAME : 'チャット';
    const notInchatName = chatNameObj !== undefined ? chatNameObj.NOINCHAT_NAME : '退席';
    const participateName = chatNameObj !== undefined ? chatNameObj.PARTICIPATE_NAME : '連携';
    headCells[1].label = chatNameObj !== undefined ? chatNameObj.ADDRESS_NAME : '宛名番号';
    headCells[2].label = chatNameObj !== undefined ? chatNameObj.USER_NAME : 'ニックネーム';
    headCells[3].label = participateName;
    const handleRequestSort = (_event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangeAllUserCheck = (event) => {
        const copyAllData = allData;
        let res;
        if(!allUpdate){
            res = window.confirm('すべて選択しますか？');
        }
        else{
            res = window.confirm('すべての選択を解除しますか？');
        }
        if(res){
            for(let i = 0; i < copyAllData.length; i++ ){
                if(copyAllData[i].participate){
                    copyAllData[i].checked = event.target.checked;
                }
            }
            setData(copyAllData);
            setAllUpdate(allUpdate ? false : true);
        }
    };


    const handleChangeUserCheck = (event, userData) => {
        const copyAllData = allData;
        for(let i = 0; i < copyAllData.length; i++ ){
            if(copyAllData[i].address === userData.address){
                copyAllData[i].checked = event.target.checked;
                break;
            }
        }
        setUpdata(update ? false : true);
        setData(copyAllData);
    };

    return (
        <React.Fragment>
            { isLoading ? (
                <ReactLoading
                    className={classes.center}
                    type={'spin'}
                    color={'black'}
                    height={'50px'}
                    width={'50px'}
                />
            )
            :
            (
                <Paper className={classes.paper}>
                    <TableContainer>
                        <Table className={classes.table} aria-labelledby="tableTitle" aria-label="draft table">
                            <ChatUserTableHead
                                classes={classes}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                                rowCount={datas.length}
                                allUpdateFlg={allUpdate}
                                allUpdate={handleChangeAllUserCheck}
                                allData={allData}
                            />

                            <TableBody>
                                {datas.map((data, index) => {
                                    const labelId = `deliveryError-data-table-checkbox-${index}`;
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            // key={data.recordId}
                                            key={data.address}
                                        >
                                            { data.participate ? (
                                                <TableCell
                                                    component="th"
                                                    id={labelId}
                                                    // scope='row'
                                                    padding={headCells[0].disablePadding ? 'none' : 'default'}
                                                    align={'center'}
                                                    style={{minWidth: '100px', textAlign: headCells[0].textAlign}}
                                                >

                                                <Checkbox
                                                    checked={data.checked} onChange={(event) => handleChangeUserCheck(event, data)}
                                                />
                                                </TableCell>
                                            )
                                            :
                                            (
                                                <TableCell
                                                    component="th"
                                                    id={labelId}
                                                    // scope='row'
                                                    padding={headCells[0].disablePadding ? 'none' : 'default'}
                                                    align={'center'}
                                                    style={{minWidth: '100px', textAlign: headCells[0].textAlign}}
                                                >

                                                <Checkbox disabled />
                                                </TableCell>
                                            )}

                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[1].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[1].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.address}</p>
                                                </div>
                                            </TableCell>

                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[2].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[2].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.fullName}</p>
                                                </div>
                                            </TableCell>

                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[3].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[3].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.participate ? `${participateName}済み` : `未${participateName}`}</p>
                                                </div>
                                            </TableCell>

                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[4].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[4].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.userId}</p>
                                                </div>
                                            </TableCell>

                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[5].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[5].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.status ? `${inchatName}中` : `${notInchatName}中` }</p>
                                                </div>
                                            </TableCell>

                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}
            { allData.length !== 0 && !isLoading && (
                <Typography className={classes.lengthTypography}>
                    {`送信人数：${allData.filter((d) => d.checked === true).length}人`}
                </Typography>
            )}
        </React.Fragment>
    );
});

ChatUserTable.propTypes = {
    classes: PropTypes.object.isRequired,
    datas: PropTypes.array.isRequired,
    allData: PropTypes.array.isRequired,
    setData: PropTypes.func.isRequired,
};

ChatUserTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    allUpdateFlg: PropTypes.bool.isRequired,
    allUpdate: PropTypes.func.isRequired,
    allData: PropTypes.array.isRequired
};

export default withStyles(styles)(ChatUserTable);